export const updateObject = <T>(oldObject: T, updatedProps: Partial<T>) => {
  return {
    ...oldObject,
    ...updatedProps,
  };
};

export default updateObject;
